var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketCreated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 64,
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3898 29.5293L47.498 29.4733V29.3516V24.4018V24.2018H47.298H11.2995H11.0995V24.4018V29.3516V29.4714L11.2051 29.5279C13.2475 30.6221 14.6994 32.7333 14.6994 35.2014C14.6994 37.7457 13.2463 39.8563 11.2051 40.9498L11.0995 41.0064V41.1261V46.0009V46.2009H11.2995H47.298H47.498V46.0009V41.1261V41.0044L47.3898 40.9485C45.279 39.8566 43.8981 37.7488 43.8981 35.2014C43.8981 32.7302 45.2778 30.6217 47.3898 29.5293ZM50.6978 24.4018V32.0015H50.2978C48.4592 32.0015 47.098 33.4443 47.098 35.2014C47.098 37.0367 48.4624 38.4012 50.2978 38.4012H50.6978V46.0009C50.6978 47.9126 49.1401 49.4007 47.298 49.4007H11.2995C9.38509 49.4007 7.89971 47.9153 7.89971 46.0009V38.4012H8.29968C10.0568 38.4012 11.4995 37.04 11.4995 35.2014C11.4995 33.441 10.0601 32.0015 8.29968 32.0015H7.89971V24.4018C7.89971 22.5597 9.3878 21.002 11.2995 21.002H47.298C49.1374 21.002 50.6978 22.5624 50.6978 24.4018Z",
    fill: "#808285",
    stroke: "white",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4577 34.6401L20.3481 26.5305C19.567 25.7494 18.3007 25.7494 17.5197 26.5305L15.7593 28.2909C14.9782 29.0719 14.9782 30.3383 15.7593 31.1193L27.0434 42.4035C27.8245 43.1845 29.0908 43.1845 29.8719 42.4035L55.6685 16.6069C56.4495 15.8258 56.4495 14.5595 55.6685 13.7784L53.9081 12.0181C53.127 11.237 51.8607 11.237 51.0797 12.0181L28.4577 34.6401Z",
    fill: "#88C139",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketCreated);
export default __webpack_public_path__ + "static/media/ticket-created.e80a6cad72ba6724c5731cb1ee10a6d5.svg";
export { ForwardRef as ReactComponent };